import { logoutExt } from '~/logicJs/LogoutUtils'
import {
  safeGetItem,
  safeSetItem,
  safeRemoveItem,
} from '~/logicJs/StorageUtils'

let intervalCheck = null
let mouseMoveHandler = null

export function checkDisconnect(store) {
  // check if user logedin or not and via (GET_USERID) if user logedin and trys to go to '/' path (login)
  // stops code exception

  // console.log("Inside checkDisconnect - store.getters.GET_CURRENT_USER", store.getters.GET_CURRENT_USER);
  let timeOut =
    store.getters.GET_TRUST_CENTER_DB.find(
      (i) => i.type === 'trustCenterSettings'
    )?.timeOut ?? 30 // default 30 minutes

  if (timeOut === 'never') {
    // console.log("Inside never statment");
    return // stops code exception same as logoutCancel if == true
  }

  if (timeOut !== 'never') {
    timeOut = parseInt(timeOut) * 60 * 1000 // convert to milliseconds
  }
  //  console.log("timeOut", timeOut);

  if (_.isEmpty(_.get(store.getters.GET_CURRENT_USER, 'email'))) {
    // console.log("User not logged in or email not set, skipping disconnect check.");
    return
  }

  // dynamicTime options - 15m 30m 60m 24h never - defult is 30
  let timeToDisconnect = timeOut

  // safe* wrappers: localStorage access throws SecurityError when the
  // visitor's browser blocks storage (TRUSTPAGE-K) — treat as best-effort.
  let lastActivity = safeGetItem('activity')

  let diff = Date.now() - lastActivity
  // console.log(
  //   'diff, timeToDisconnect, store.getters.GET_USER_ATTRIBUTE, ',
  //   diff,
  //   timeToDisconnect,
  //   store.getters.GET_USER_ATTRIBUTE
  // )
  let preventLogoutTwice = safeGetItem('preventLogoutTwice')
  if (diff > timeToDisconnect && !preventLogoutTwice) {
    // Check if user logged in and if time inactivity is passed and logoutFeature is not canceled
    store.commit('SET_LOGOUT', true) // To set the loader and prevent the UI to be used
    console.log('Disconnected')
    safeSetItem('preventLogoutTwice', true)
    setTimeout(() => {
      safeRemoveItem('preventLogoutTwice')
    }, 1500)
    logoutExt(
      (user) => store.commit('SET_CURRENT_USER', user),
      (token) => store.commit('SET_TOKEN', token)
    )
    return true
  }
}

export default async ({ store, app }) => {
  checkDisconnect(store, app.router)

  // Clean previous interval if it exists
  if (intervalCheck) {
    clearInterval(intervalCheck)
    intervalCheck = null
  }

  intervalCheck = setInterval(() => {
    //Check every x second if we have to disconnect
    checkDisconnect(store, app.router)
  }, 1000)

  // Remove previous mousemove handler
  if (mouseMoveHandler) {
    window.removeEventListener('mousemove', mouseMoveHandler)
    mouseMoveHandler = null
  }

  // Define new debounced handler
  mouseMoveHandler = _.debounce(() => {
    // console.log("Activity updated");
    // This debounced write is the exact crash site of Sentry TRUSTPAGE-K:
    // it runs inside lodash's trailing-edge timer, so a blocked-storage
    // SecurityError surfaced as an unhandled error with no first-party frame.
    safeSetItem('activity', Date.now())
  }, 200)

  window.addEventListener('mousemove', mouseMoveHandler)

  // Optional but safer: clean on tab close or reload
  window.addEventListener('beforeunload', () => {
    if (intervalCheck) {
      clearInterval(intervalCheck)
      intervalCheck = null
    }
    if (mouseMoveHandler) {
      window.removeEventListener('mousemove', mouseMoveHandler)
      mouseMoveHandler = null
    }
  })
}
